query CustomerGuide($materialId: ID!) {
  customerGuide(materialId: $materialId) {
    materialId
    publishedVersion
    publishedFile {
      id
      cdnUrl(named: true)
    }
    previewFile {
      id
      cdnUrl
    }
    replacementState
    failureState
    canRegenerate
    canEdit
  }
}
